import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=f27a0c62&scoped=true&"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteConfirmation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DeleteConfirmation.vue?vue&type=style&index=1&id=f27a0c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27a0c62",
  null
  
)

export default component.exports